module.exports = __webpack_public_path__ + "img/8C.873c8cc4.svg";